<!--suppress ALL -->

<template>
  <div>
<!--    <Upload ref="upload" :action="this.$fileUploadPath" name="file"-->
<!--            :before-upload="handleBeforeUpload" :show-upload-list="true" :on-format-error="handleFormatError"-->
<!--            :on-success="handleSuccess" :on-error="handleError" :format="[]">-->
<!--      <Button type="default" icon="ios-cloud-upload-outline" style="">选择文件</Button>-->
<!--    </Upload>-->

    <el-upload
      ref="upload"
      :action="metaData ? this.$fileUploadPathMeta:this.$fileUploadPath"
      name="file"
      :before-upload="handleBeforeUpload"
      :show-file-list="false"
      :on-success="handleSuccess"
      accept="video/*"
    >
      <el-button type="default" icon="el-icon-upload2">{{uploadText}}</el-button>
    </el-upload>
    <div style="margin-top: 20px">
      <video style="width: 150px; height: auto" :src="videoUrl" class="video-avatar" controls="controls" v-if="videoUrl!=''">
        您的浏览器不支持视频播放
      </video>
    </div>
    <div>
      <el-button type="text" size="small" @click="choose">从视频库选择</el-button>
    </div>
    <video-choose ref="videoChoose" @refresh="chooseVideo"></video-choose>

  </div>
</template>


<script>

import VideoChoose from "@/components/VideoChoose"

export default {
  name: 'VideoUpload',
  props: {
    originFileRequire: {
      type: Boolean,
      default: false
    },

    metaData: {
      type: Boolean,
      default: false
    },

    uploadText: {
      type: String,
      default: '上传视频'
    },
  },
  data() {
    return {
      fileNameView: '',
      videoUrl:''
    }
  },

  components:{
    VideoChoose
  },
  methods: {

    choose(){
      this.$refs.videoChoose.init()
    },


    fileNameViewDelect() {
      this.fileNameView = ''
    },

    handleBeforeUpload(file) {
      // 在这里你可以直接操作原始文件
      console.log('原始文件:', file)
      this.originFile = file
      this.fileNameView = file.name
      if (this.originFileRequire){
        this.$emit('upload-success',  this.originFile);
        return false;
      }
      return true
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件 ' + file.name + ' 格式不正确'
      })
    },
    handleSuccess(res, file) {
      if (res.status === 1) {
        this.videoUrl = res.data.url
        this.$emit('upload-success',  res.data.url, file.name, res.data);
      } else {
        this.$Message.error(res.errorMsg)
      }
    },

    chooseVideo(e){
      this.videoUrl = e
      this.$emit('upload-success',  e);
    },

    handleError(error, file) {
      this.$Message.error('上传失败！')
    },

  }

}
</script>
<style scoped >
@import '../assets/global.css';
</style>
